<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-gradient-primary fixed-top">
    <div class="container">
      <router-link class="navbar-brand fw-bold d-flex align-items-center" to="/">
        <div class="brand-icon me-2">
          <i class="bi bi-building"></i>
          <i class="bi bi-car-front position-absolute"></i>
        </div>
        ImmobilAutoManager
      </router-link>

      <button
        class="navbar-toggler border-0"
        type="button"
        @click="toggleMenu"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="collapse navbar-collapse justify-content-end"
        id="navbarNav"
        :class="{ 'show': isMenuOpen, 'closing': isClosing }"
      >
        <ul class="navbar-nav align-items-center gap-1">
          <li class="nav-item" v-for="(item, index) in menuItems" :key="index">
            <router-link
              class="nav-link px-3"
              :to="item.to"
              active-class="active"
              @click="closeMenu"
            >
              {{ item.text }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isMenuOpen: false,
      isClosing: false,
      menuItems: [
        { to: '/', text: 'Home' },
        { to: { name: 'features' }, text: 'Caratteristiche' },
        { to: { name: 'about' }, text: 'Chi Siamo' },
        { to: { name: 'pricing' }, text: 'Prezzi' },
        { to: { name: 'faq' }, text: 'FAQ' },
        { to: { name: 'contact' }, text: 'Contatti' }
      ]
    }
  },
  methods: {
    toggleMenu() {
      if (this.isMenuOpen) {
        this.isClosing = true
        setTimeout(() => {
          this.isMenuOpen = false
          this.isClosing = false
        }, 300) // Durata dell'animazione
      } else {
        this.isMenuOpen = true
      }
    },
    closeMenu() {
      if (this.isMenuOpen) {
        this.isClosing = true
        setTimeout(() => {
          this.isMenuOpen = false
          this.isClosing = false
        }, 300)
      }
    }
  },
  watch: {
    $route() {
      this.closeMenu()
    }
  }
}
</script>

<style scoped>
.navbar {
  background: #023047;
}

.nav-link {
  color: #8ecae6 !important;
}

.nav-link:hover {
  color: #ffb703 !important;
}

.nav-link.active {
  color: #ffb703 !important;
}

.nav-link.active::after {
  background-color: #ffb703;
}

.navbar-brand {
  color: #8ecae6 !important;
}

.btn-primary {
  background: #ffb703;
  color: #023047;
  border: none;
}

.btn-primary:hover {
  background: #fb8500;
  color: #023047;
}

@media (max-width: 991.98px) {
  .navbar-collapse {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #023047;
    padding: 1rem;
    z-index: 1000;
  }

  .navbar-collapse.show {
    animation: slideDown 0.3s ease-in-out forwards;
  }

  .navbar-collapse.closing {
    animation: slideUp 0.3s ease-in-out forwards;
  }

  @keyframes slideDown {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideUp {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(-20px);
    }
  }

  .navbar-collapse.show .nav-item {
    animation: fadeIn 0.5s ease-in-out forwards;
  }

  .navbar-collapse.closing .nav-item {
    animation: fadeOut 0.3s ease-in-out forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(10px);
    }
  }

  /* Ritardo inverso per l'animazione di chiusura */
  .navbar-collapse.closing .nav-item:nth-child(6) { animation-delay: 0s; }
  .navbar-collapse.closing .nav-item:nth-child(5) { animation-delay: 0.05s; }
  .navbar-collapse.closing .nav-item:nth-child(4) { animation-delay: 0.1s; }
  .navbar-collapse.closing .nav-item:nth-child(3) { animation-delay: 0.15s; }
  .navbar-collapse.closing .nav-item:nth-child(2) { animation-delay: 0.2s; }
  .navbar-collapse.closing .nav-item:nth-child(1) { animation-delay: 0.25s; }

  .navbar-toggler {
    transition: transform 0.3s ease;
  }

  .navbar-toggler:active {
    transform: scale(0.95);
  }
}

.brand-icon {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
}

.brand-icon i:first-child {
  font-size: 1.2rem;
  position: relative;
  top: -5px;
}

.brand-icon i:last-child {
  font-size: 0.9rem;
  bottom: -3px;
  right: -5px;
  position: absolute;
}

@media (min-width: 992px) {
  .navbar-collapse {
    display: flex !important; /* Forza la visualizzazione su desktop */
    height: auto !important;
    visibility: visible !important;
  }
}
</style>
